import React, { Component } from "react";
import PropTypes from "prop-types";
import "./NewConcern.css";

class NewConcern extends Component {
  constructor() {
    super();

    this.state = {
      newConcern: "",
      newReporter: "",
      emptyConcernError: false,
    };
  }

  handleNewConcernChange = event => {
    var newConcern = event.target.value;

    this.setState({
      newConcern: newConcern,
    });
  };

  handleNewReporterChange = event => {
    var newReporter = event.target.value;

    this.setState({
      newReporter: newReporter,
    });
  };

  handleAddConcern = event => {
    event.preventDefault();

    if (this.state.newConcern.length > 0) {
      this.props.commitNewConcern(
        this.state.newConcern,
        this.state.newReporter
      );

      this.setState({
        newConcern: "",
        newReporter: "",
      });
    } else {
      this.setState({
        emptyConcernError: true,
      });
    }

    setTimeout(() => this.newConcernInput.focus(), 500); //Need the delay so that the page can properly scroll to the top
  };

  render() {
    return (
      <form className="new-concern-container" onSubmit={this.handleAddConcern}>
        <div
          className="editable-container new-concern-text-container"
          onClick={() => this.newConcernInput.focus()}
        >
          <input
            type="text"
            className="editable-input new-concern-input"
            placeholder="What's the concern?"
            value={this.state.newConcern}
            onChange={this.handleNewConcernChange}
            ref={input => (this.newConcernInput = input)}
          />
          <div className="save-hint">
            Press <span className="blue">TAB</span> to{" "}
            <span className="right-arrow">&rarr;</span> or{" "}
            <span className="blue">ENTER</span> to save
          </div>
        </div>
        <div
          className="editable-container new-reporter-container"
          onClick={() => this.newReporterInput.focus()}
        >
          <input
            type="text"
            className="editable-input new-reporter-input"
            placeholder="Reported by?"
            value={this.state.newReporter}
            onChange={this.handleNewReporterChange}
            ref={input => (this.newReporterInput = input)}
          />
          <div className="save-hint">
            Press <span className="blue">Enter</span> to save
          </div>
        </div>
        <button
          style={{
            visibility: "hidden",
            padding: "0",
            margin: "0",
            border: "none",
          }}
          type="submit"
        />
      </form>
    );
  }
}

NewConcern.propTypes = {
  commitNewConcern: PropTypes.func.isRequired,
};

export default NewConcern;



// WEBPACK FOOTER //
// ./src/components/NewConcern.js